import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=58019076&"
import script from "./AppContent.vue?vue&type=script&lang=ts&"
export * from "./AppContent.vue?vue&type=script&lang=ts&"
import style0 from "buefy/dist/buefy.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/assets/materialdesign/css/materialdesignicons.min.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./AppContent.vue?vue&type=style&index=2&id=58019076&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports